import { BaseDynamoClass, baseDynamoSchema } from "./BaseDynamoClass";
import { StripUnderscore, UnderscoreKeys } from "../util/Types";
import z from "zod";

export const userOwnedSchema = baseDynamoSchema.extend({
  _userId : z.string().nonempty(),
  _identityId : z.string().optional()
});

export type UserOwnedFields = StripUnderscore<z.infer<typeof userOwnedSchema>>;
export abstract class UserOwnedClass<TFields extends UserOwnedFields = UserOwnedFields> extends BaseDynamoClass<TFields> {
	_userId!: string;
	_identityId?: string;

	constructor(props? : Partial<TFields>){
		super(props);
	}

	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [
			...super.getFieldList(),
			"_userId",
			"_identityId"
		]
	}

	get userId() : string {
		return this.checkFieldType<"userId">(this._userId);
	}
	set userId(value: string) {
		this._userId = this.checkFieldTypeAndMark<"userId">("_userId", value);
	}
	get identityId() : string | undefined {
		return this.checkFieldType<"identityId">(this._identityId!);
	}
	set identityId(value: string | undefined) {
		this._identityId = this.checkFieldTypeAndMark<"identityId">("_identityId", value);
	}
}
